/**
 * Copyright (c) 2018 Microsoft Corporation
 */
import { getPayloadObject, getTelemetryAttributes, IPayLoad, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDropdownItemProps, IDropdownOnSelectionChangeNotification } from './dropdown/dropdown.props';
import { observer } from 'mobx-react';
import { ProductDimensionValue } from '@msdyn365-commerce/retail-proxy';
import { IBuyboxGetDimensionVariantAvailabilityActionData } from '../../../data-actions/buybox-get-dimension-variants-availability-action';
type IHeightFoundationState = {
    /**
     * @friendlyName selectedIndex
     * @description selected index
     */
    selectedIndex: string;
    /**
     * @friendlyName preSelectionSet
     * @description is a preselection set for the dropdown
     */
    preSelectionSet?: boolean;
};
export interface IDimensionProps {
    /**
     * @friendlyName dropdownId
     * @description Id for dropdown component
     */
    dimensionId: string;
    /**
     * @friendlyName variantAvailibilityList
     * @description array for checking variant aviability
     */
    variantAvailibilityList: IBuyboxGetDimensionVariantAvailabilityActionData[];
    /**
     * @friendlyName dropdownName
     * @description Name of the dropdown component
     */
    dimensionName: string;
    selectedSize: string;
    dimensionValue?: ProductDimensionValue;
    /**
     * @friendlyName dropdownList
     * @description List of items in dropdown
     */
    dimensionList: IDropdownItemProps[];
    /**
     * @telemetryContent telemetryContent
     * @description telemetry content
     */
    telemetryContent?: ITelemetryContent;
    /**
     * @friendlyName onChange
     * @description Callback that gets fired when when a selected dimension changes
     */
    onChange?(notification: IDropdownOnSelectionChangeNotification): Promise<void>;
    setActiveVariant(variantID: number): void;
}
/**
 *
 * DropDown component
 * @extends {React.PureComponent<IDimensionProps, IHeightFoundationState>}
 */
@observer
export class HeightFoundationComponent extends React.PureComponent<IDimensionProps, IHeightFoundationState> {
    private selectMenu: React.RefObject<HTMLSelectElement> = React.createRef<HTMLSelectElement>();
    private payLoad: IPayLoad;
    constructor(props: IDimensionProps, state: IHeightFoundationState) {
        super(props);
        {
            /* VSI Customization - START */
        }
        const selectedValue = this.props?.dimensionValue?.RecordId?.toString() || '';
        this.state = {
            selectedIndex: selectedValue
        };
        {
            /* VSI Customization - END */
        }
        this.payLoad = getPayloadObject('click', props.telemetryContent!, this.props.dimensionName);
    }
    public componentDidMount(): void {
        {
            /* VSI Customization - START */
        }
        if (this.selectMenu.current && this.state.selectedIndex === '') {
            this.selectMenu.current.selectedIndex = 0;
        }
        {
            /* VSI Customization - END */
        }
    }
    public componentDidUpdate(): void {
        const selectedValue = this.props?.dimensionValue?.RecordId?.toString() || '';
        selectedValue && !this.state.preSelectionSet && this.setState({ selectedIndex: selectedValue, preSelectionSet: true });
    }
    public render(): JSX.Element {
        const { dimensionList } = this.props;
        const attribute = getTelemetryAttributes(this.props.telemetryContent!, this.payLoad);
        return (
            <>
                <ul className='msc-dimensions' {...attribute}>
                    {dimensionList.map(
                        (item) => {
                            const isAvailable = this.props.variantAvailibilityList.find(dim => dim.sizeValue.toLowerCase() === this.props.selectedSize.toLowerCase() && dim.colorDimensionRecordId.toString() === item.id)?.isAvailable;
                            const isActive = this.state.selectedIndex === item.id.toString();
                            const classNames = !isAvailable ? 'msc-dimensions-wrapper msc-dimensions-wrapper-disable' : isActive ? 'msc-dimensions-wrapper msc-dimensions-wrapper-active' : 'msc-dimensions-wrapper';
                            const currentVariantId = this.props.variantAvailibilityList.find(dim => dim.sizeValue.toLowerCase() === this.props.selectedSize.toLowerCase() && dim.colorDimensionRecordId.toString() === item.id)?.variantID;
                            if (isActive) {
                                currentVariantId && this.props.setActiveVariant(currentVariantId);
                            }
                            return (
                                item && <li
                                    className={classNames}
                                    id={item.id}
                                    key={item.id}
                                    tabIndex={0}
                                    onClick={() => this._handleOnClick(item.id, item.value)}
                                    role='button'
                                >
                                    <button disabled={!isAvailable} className={`${isActive ? 'active' : ''}`} >{item.value}</button>
                                </li>
                            );
                        }
                    )}
                </ul>
            </>
        );
    }
    private _handleOnClick = async (selectedId: string, selectedValue: string) => {
        this.setState({ selectedIndex: selectedId });
        if (this.props.onChange) {
            await this.props.onChange({
                dropdownId: this.props.dimensionId,
                selectId: selectedId,
                selectedValue: selectedValue
            });
        }
    };
}
